import { SalesOrderStatus } from "./salesOrder";

export const PAYMENT_STATUS = {
  PENDING: "pending",
  APPROVED: "approved",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
} as const;

export type PaymentStatus =
  (typeof PAYMENT_STATUS)[keyof typeof PAYMENT_STATUS];

interface OrderBase {
  orderId: string;
  orderCode: string;
  orderCreatedAt: number;
  partnerCode: string;
  partnerName: string;
  status: SalesOrderStatus;
  totalAmount?: number;
  paidAmount: number;
  remainingAmount: number;
  contactPerson?: {
    id: string;
    code: string;
    fullname: string;
    phone: string | null;
  };
}

export interface Payment {
  code: string;
  amount: number;
  paymentDate: number;
  status: PaymentStatus;
  bankAccountName: string;
}

export interface CollectionReportDetail extends OrderBase {
  totalAmount: number;
  payments: Payment[];
}

export interface ProfitReportRow extends OrderBase {
  totalRevenue: number;
  totalCost: number;
  grossProfit: number;
  realizedProfit: number;
  items: ProfitReportItem[];
}

export interface ProfitReportItem {
  itemId: string;
  productId: string;
  productCode: string;
  productName: string;
  productSpec: string | null;
  productDisplayName: string;
  productUnit: string;
  quantity: number;
  unitPrice: number;
  amountBeforeTax: number;
  taxAmount: number;
  totalAmount: number;
  priceNet: number;
  totalCost: number;
  profit: number;
}

export interface ProfitReportSummary {
  orderCount: number;
  totalRevenue: number;
  totalCost: number;
  totalPaid: number;
  totalRemaining: number;
  totalGrossProfit: number;
  totalRealizedProfit: number;
}

export interface SummaryCardProps {
  label: string;
  value: string;
  color?: string;
}

export interface ProfitSummaryCardsProps {
  summary: ProfitReportSummary;
}

export interface ProfitReportResponse {
  rows: ProfitReportRow[];
  summary: ProfitReportSummary;
}

/** Một dòng báo cáo "Tình hình mua hàng" — mỗi mặt hàng trên đơn là một dòng */
export interface PurchaseReportRow {
  orderId: string;
  orderCode: string;
  orderCreatedAt: number;
  /** "07/08/2026 -3" — ngày đơn kèm số thứ tự trong ngày */
  dateCode: string;
  partnerName: string;
  productName: string;
  productSpec: string | null;
  productDisplayName: string;
  productUnit: string;
  quantity: number;
  unitPrice: number;
  totalAmount: number;
}
